"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOM = void 0;
class DOM {
    static deselectAllNodes() {
        if (DOM.lock)
            return;
        document.querySelectorAll(`.${DOM.classes.node}`).forEach((n) => n.classList.remove(DOM.classes.nodeSelected));
    }
    static selectNodeByIndex(index) {
        if (DOM.lock)
            return;
        document.querySelectorAll(`.${DOM.classes.node}`).forEach((n, i) => {
            if (i === index) {
                DOM.selectNode(n);
            }
        });
    }
    static selectNode(node) {
        if (DOM.lock)
            return;
        node.classList.add(DOM.classes.nodeSelected);
    }
}
exports.DOM = DOM;
DOM.lock = false;
DOM.panLock = false;
DOM.scrollLock = false;
DOM.keyLock = false;
DOM.classes = {
    node: 'DOMNode',
    nodeSelected: 'DOMSelectedNode',
};
